export default "__VITE_ASSET__Cvi5RUiA__"